function normalizeCaptchaEnable(value) {
  return String(value) === '1' ? '1' : '0'
}

function isCaptchaEnabled(value, ready = true) {
  return ready && normalizeCaptchaEnable(value) === '1'
}

module.exports = {
  normalizeCaptchaEnable,
  isCaptchaEnabled
}
